export default "__VITE_ASSET__da300101__"